import { JSX } from 'react';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';

export const HTML = ({
	html,
	onChange,
	id, //ignore it to avoid duplicate
	..._props
}: JSX.IntrinsicElements['div'] & { html?: string }) => {
	const props = cleanBoxProps(_props);
	return <div {...props} dangerouslySetInnerHTML={{ __html: html ?? '' }} />;
};
